"use strict";

exports.__esModule = true;
exports.getMetricFieldDefinition = getMetricFieldDefinition;
exports.metricFieldDefinitions = void 0;
var _timeDefinitions = require("../../Components/timeDefinitions");
var metricFieldDefinitions = exports.metricFieldDefinitions = [{
  name: "timestamp",
  label: "Timestamp",
  description: "Time of the context event.",
  filterTypes: ["range", "term"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "range",
      values: {
        gte: new Date(Date.now() - _timeDefinitions.DAY_IN_MILLIS * 3).toISOString(),
        lte: new Date(Date.now() + _timeDefinitions.DAY_IN_MILLIS).toISOString()
      }
    };
  }
}, {
  name: "workday",
  label: "Workday",
  description: "Workday associated with the context event.",
  filterTypes: ["range", "term"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "range",
      values: {
        gte: new Date(Date.now() - _timeDefinitions.DAY_IN_MILLIS * 3).toISOString().split("T")[0],
        lte: new Date(Date.now() + _timeDefinitions.DAY_IN_MILLIS).toISOString().split("T")[0]
      }
    };
  }
}, {
  name: "shift",
  label: "Shift",
  description: "Shift associated with the context event.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "device_id",
  label: "Device",
  description: "Identifier (uuid) of a device at a plant.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "operator_id",
  label: "Operator",
  description: "ID of the operator.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "plant_id",
  label: "Plant",
  description: "ID of the plant.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "component_id",
  label: "Component",
  description: "ID of the component.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "kind_id",
  label: "Part Kind",
  description: "Part kind.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "classification.state",
  label: "State",
  description: "The classification state.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "classification.activity",
  label: "Activity",
  description: "The classification activity.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "classification.usage",
  label: "Usage",
  description: "The classification usage.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "classification.process_quality",
  label: "Process Quality",
  description: "The classification process quality.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "part_id",
  label: "Part",
  description: "The part.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "process_id",
  label: "Process",
  description: "The process.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "part_instance_id",
  label: "Part Instance",
  description: "The part instance.",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}, {
  name: "tool_number_id",
  label: "Tool Number",
  description: "The tool number",
  filterTypes: ["term", "terms"],
  getDefaultFilter: function getDefaultFilter() {
    return {
      filterType: "term",
      values: null
    };
  }
}];

/**
 * Get the definition for the metric field with the given name.
 */
function getMetricFieldDefinition(name) {
  for (var i = 0; i < metricFieldDefinitions.length; i++) {
    var definition = metricFieldDefinitions[i];
    if (definition.name === name) {
      return definition;
    }
  }
  throw new Error("Unknown metric field: " + name);
}